module.exports = __webpack_public_path__ + "static/img/nghidinh.193d947.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/nghidinh.jpg
// module id = nzyF
// module chunks = 1